import ApiBase from 'app/services/api/entities/Base'
import FiscalInfo from 'app/services/api/entities/fiscalInfo'

function* getStatus() {
  return yield ApiBase.privateGet(`/v1/user_onboarding_status/`)
}

function* getContracts(brokerId) {
  return yield ApiBase.privateGet(`/v1/neximer_documents/${brokerId}/documents/`)
}

function* acceptContract(documentName) {
  return yield FiscalInfo.acceptDocument(documentName)
}

export default {
  getStatus,
  getContracts,
  acceptContract,
}